(function($){
    let new_animate = function(){
        let banner_new = $('.banner .item-content');
        banner_new.addClass('animate__animated animate__zoomIn showed');
        setTimeout(function(){
            banner_new.removeClass('animate__animated animate__zoomIn');
        }, 1500)
    }

    let banner_title_animate = function(){
        $('.banner_description h2').addClass('animate__animated animate__fadeIn visible');
        $('.banner_description p').addClass('animate__animated animate__fadeIn visible');
    }

    let animate = function(element, type){
        let window_scroll = $(window).scrollTop() + $(window).outerHeight() - 150;

        if(window_scroll > element.offset().top){
            element.addClass('animate__animated animate__' + type + ' visible');
        }
    }

    $(document).ready(function(){
        setTimeout(banner_title_animate, 1200)
        setTimeout(new_animate, 1700)
    })

    $(window).scroll(function(){

        // $('.section-title').each(function(){
        //     animate($(this), 'slideInLeft');
        // })

        $('.slideInRight').each(function(){
            animate($(this), 'slideInRight');
        })
        $('.zoomIn').each(function(){
            animate($(this), 'zoomIn');
        })
        // $('.fadeIn').each(function(){
        //     animate($(this), 'zoomIn');
        // })

    })
})(jQuery)
